module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('slide', {
    attrs: {
      "ratio": 120 / 320,
      "surface": [{
          imgUrl: 'http://mlo.jishi88.com/dist/v1.3.7/2.png?870bbc643c89ab370522a8eea9cf4985'
        },
        {
          imgUrl: 'http://mlo.jishi88.com/dist/v1.3.7/1.png?99a3d4cc476cce3ed4826cd912b12876'
        },
        {
          imgUrl: 'http://mlo.jishi88.com/dist/v1.3.7/3.png?b13d9da72fe03c029ff79e1720a318b7'
        }
      ]
    }
  }), _vm._v(" "), _c('slide', {
    attrs: {
      "ratio": 120 / 320
    }
  }, [_c('slide-item')], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-136e612b!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/slide/demo.vue
// module id = 225
// module chunks = 12